import { navigateTo, replaceWith } from '../navigation'
import { NotificationsActions } from '../Actions/notificationsActions'
import store from '../Store'

export default function handleErrors(response) {
  const code = response.status

  switch (code) {
    case 451:
      replaceWith('/pending-agreements');
      break;
    case 422:
      response.json().then((json) => {
        let errors = Object.values(json);

        if (errors.length == 0) {
          store.dispatch(NotificationsActions.displayErrorSnackbar(response.statusText))
        } else {
          errors.forEach((error) => {
            store.dispatch(NotificationsActions.displayErrorSnackbar(error))
          })
        }
      })
      break;
    case 400:
    case 401:
      localStorage.clear()
      navigateTo('/');
      break;
    case 403:
    case 404:
    case 424:
    case 500:
    case 503:
      store.dispatch(NotificationsActions.displayErrorSnackbar(response.statusText));
      break;
  }
}
